<template>
	<div>
    <content-data v-if="is_settings" :list="list_id" editpath="/devices/locations/list/" :disable-import="true" :search="data_search"></content-data>

    <action-buttons @add="open_add"></action-buttons>

  </div>
</template>

<script>
import ContentData from '../content/Data'
import SettingsModel from '@/models/settings.js';
import ActionButtons from '@/components/ActionButtons.vue'

export default {
	components: {
		ContentData,
    ActionButtons
	},
  data () {
    return {
    }
  },
  methods:{
    open_add() {
      this.$router.push("/devices/locations/list/" + this.list_id + "/data/new");
    }
  },
  mounted () {
  },
  computed: {
    data_search () {
      return this.$store.state.search_text;
    },
    is_settings() {
      if (this.settings.length > 0) return true;
      return false;
    },
    settings () {
      return SettingsModel.list("device_type");
    },
    list_id() {
      return this.settings[0].value.location_list_id;
    }
  }
}
</script>